'use client';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { useShopifyCart } from '../../shopify/useShopifyCart';
import { ShopifyCartContext } from './ShopifyCartProvider';

export const AppShopifyCartProvider = ({ children }) => {
  const pathname = usePathname();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);

  useEffect(() => {
    setShouldCreateCart(pathname?.includes('/onboarding') ?? false);
    setHasCheckedPath(true);
  }, [pathname]);

  const cartState = useShopifyCart({
    shouldCreateCart,
    hasCheckedPath,
  });

  return (
    <ShopifyCartContext.Provider value={cartState}>
      {children}
    </ShopifyCartContext.Provider>
  );
};
